<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <form id="UpdateLesson" @submit.prevent="UpdateLesson" >
        <CCardHeader>
            <CCol col="6" style="font-size: 25px;">تعديل الدرس</CCol>
        </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm='4'>
                <div class='form-group'>
                    <label for='courses'>
                      الكورس
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedCourse'
                        id='courses'
                        @select="onCourseChange($event)"
                        :options='courses'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر الكورس '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.course_id) class="invalid-feedback">
                        {{errors.course_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
              <CCol sm='4'>
                <div class='form-group'>
                    <label for='sections'>
                      الوحدات
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required'
                        v-model='selectedSection'
                        id='sections'
                        :options='sections'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر الوحدة '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <div v-if(errors.section_id) class="invalid-feedback">
                        {{errors.section_id}}
                      </div>
                    </div>
                  </div>
              </CCol>
            </CRow>
            <hr/>
            <CRow>
              <CCol sm="6">
                <CInput label=" Title"
                  id="title"
                  v-model="lesson.title"
                  class="required"
                  placeholder=" أدخل عنوان الدرس بالانجليزية"
                  :invalidFeedback="errors.title"
                  required
                />
              </CCol>
              <CCol sm="6">
                <CInput label="عنوان"
                  id="title"
                  v-model="lesson.title_ar"
                  class="required"
                  placeholder="أدخل عنوان الدرس بالعربي"
                  :invalidFeedback="errors.title_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="2">
                <div class='form-group'>
                    <input type="checkbox" class="form-control form-check-input" id="lesson-free" v-model="lesson.free" :checked="lesson.free" @change="changeLessonFree(lesson)">
                    <label class="form-check-label" for="lesson-free">مجاني</label>
                </div>
              </CCol>
              <div class="col-md-6">
                <div class='form-group'>
                  <label for='video'>
                    الفديو القديم
                  </label>
                <video ref="videoRef" src="" id="video-container" controls width="80%"></video>
                </div>
              </div>
              <CCol sm="4">
                <div class='form-group'>
                  <label for='video'>
                    الفديو
                  </label>
                  <input type="file" class="form-control"
                    id="video"
                    v-on:change="onFileChange"
                  >
                  <div v-if(errors.video) class="invalid-feedback">
                    {{errors.video}}
                  </div>
                </div>
                <progress max="100" :value.prop="uploadPercentage" class="progress-bar bg-success progress-bar-striped progress-bar-animated loading"></progress>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى  بالإنجليزية'
                  horizontal
                  rows='4'
                  v-model='lesson.description'
                  :invalidFeedback="errors.description"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label='الوصف (اختياري)'
                  placeholder='المحتوى بالعربي'
                  horizontal
                  rows='4'
                  v-model='lesson.description_ar'
                  :invalidFeedback="errors.description_ar"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="button" size="sm" color="warning" @click="goBack"><CIcon name="cil-ban"/> رجوع </CButton>
          </CCardFooter>
      </form>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
import $ from 'jquery'
import swal from 'sweetalert'
export default {
  name: 'CreateLesson',
  data: function () {
    return {
      lesson: {},
      courses: [],
      selectedCourse: '',
      sections: [],
      selectedSection: '',
      video: '',
      errors: []
    }
  },
  created () {
    const courses = []
    const sections = []
    this.$http
      .get(`${this.$hostUrl}lessons/${this.$route.params.id}/edit`)
      .then((response) => {
        $.each(response.data.data.sections, function (key, value) {
          sections.push({ id: value.id, name: value.name_ar })
        })
        this.sections = sections
        $.each(response.data.data.courses, function (key, value) {
          courses.push({ id: value.id, name: value.name_ar })
        })
        this.courses = courses
        this.lesson = response.data.data.lesson
        this.selectedCourse = {
          id: this.lesson.section.course.id,
          name: this.lesson.section.course.name_ar
        }
        this.selectedSection = {
          id: this.lesson.section.id,
          name: this.lesson.section.name_ar
        }
        this.$refs.videoRef.src = this.lesson.video_full_path
      })
  },
  methods: {
    onFileChange (e) {
      this.video = e.target.files[0]
    },
    onCourseChange ($event) {
      const sections = []
      this.$http
        .get(
            `${this.$hostUrl}courses/${$event.id}/sections`
        )
        .then((response) => {
          $.each(response.data.data, function (key, value) {
            sections.push({ id: value.id, name: value.name_ar })
          })
          this.sections = sections
        })
    },
    changeLessonFree (event) {
      console.log(event)
      event.free = Number((event.free ? 1 : 0))
    },
    async UpdateLesson (e) {
      const formData = new FormData()
      if (this.selectedSection) {
        formData.append('section_id', this.selectedSection.id)
      } else {
        this.errors.push('section_id')
        this.errors.section_id = 'section field is required'
        swal('يرجى تحديد موضوع للدرس')
        return 0
      }
      if (this.video) {
        formData.append('video', this.video)
      }
      if (/^\d+$/.test(this.lesson.title)) {
        swal('عنوان الدرس يجب ان يحتوي على حروف')
        return 0
      }
      if (/^\d+$/.test(this.lesson.title_ar)) {
        swal('عنوان الدرس يجب ان يحتوي على حروف')
        return 0
      }
      formData.append('title', this.lesson.title)
      formData.append('title_ar', this.lesson.title_ar)
      formData.append('_method', 'PUT')
      if (this.lesson.description) {
        formData.append('description', this.lesson.description)
      }
      if (this.lesson.description_ar) {
        formData.append('description_ar', this.lesson.description_ar)
      }
      this.errors = await this.postRequest(formData, `${this.$hostUrl}lessons/${this.$route.params.id}`, '/lessons')
    },
    goBack () {
      this.coursesOpened ? this.$router.go(-1) : this.$router.push({ path: '/lessons' })
    }
  }
}
</script>
